import React from 'react';
import PropTypes from 'prop-types';
import trackerService from '../../../../service/trackerService';
import {
  EVENT_CREATED_AT_FORMAT,
  EVENT_NAME_FOR_ARCHIVE_ORDERS,
  EVENT_SCOPE_FOR_ARCHIVE_ORDERS,
} from '../../../../shop/constants/tracker';
import dayjs from '../../../../utils/day';

const OrderNumberLink = (props) => {
  const { createdAt, href, position, orderId, orderNumber } = props;
  const handleOrderNumberClick = () => {
    trackerService.track({
      type: EVENT_NAME_FOR_ARCHIVE_ORDERS.ORDER_NUMBER_LINK_CLICK,
      data: {
        position,
        scope: EVENT_SCOPE_FOR_ARCHIVE_ORDERS.CRM,
        order_id: orderId,
        order_number: orderNumber,
        created_at: dayjs.utc(createdAt).format(EVENT_CREATED_AT_FORMAT),
      },
    });
  };

  return (
    <a href={href} onClick={handleOrderNumberClick}>
      {orderNumber}
    </a>
  );
};

OrderNumberLink.propTypes = {
  createdAt: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  orderNumber: PropTypes.string,
};

export default OrderNumberLink;
